import ClassHandler from "./common/ClassHandler";
import PackageInit from "./mixins/PackageInit";
import CropperMixin from "./mixins/Cropper";

export default class ImageCropper extends ClassHandler {
    constructor(cropArea, inputField) {
        super();

        Object.assign(this, PackageInit, CropperMixin);

        this.init = this.#init.bind(this);

        if (cropArea && inputField) {
            this.init(cropArea, inputField);
        }
    }

    #init(cropArea, inputField) {
        this.initCropper(cropArea, inputField);
    }
}
